var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './styles.module.css';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { PageLayout } from '../../Components/PageLayout';
import { MainText } from '../../Components/BaseComponents/Typography';
import { useApplication, useOrder } from '../../Contexts/ApplicationContext';
import { observer } from 'mobx-react-lite';
import { PaymentMethod, } from '../../../Services/methods/order';
import { useNFT } from '../../Contexts/SettingsContext';
import { useAnalytics } from '../../Contexts/AnalyticsContext';
import { FeatureFlag, useFeatureFlag } from '../../Contexts/FeatureFlagContext';
import { middleDots } from '../OrderDetailsPage/utils';
import { TotalFeeInfoIcon } from '../../Components/Icons/TotalFeeInfoIcon';
import { PaymentCardTypeSelect } from './PaymentMethodSelect';
import { RateIcon } from './Icons';
import { OrderValueWithTooltip } from './OrderValueWithTooltip';
import { Tooltip } from '../../Components/BaseComponents/Tooltip';
import { WarningIcons } from '../KYC/components/Icons';
import { ZeroIdBanner } from './ZeroIdBanner';
import { SelectPaymentPage } from './SelectPaymentVariant/SelectPaymentPage';
import { TextToCopy } from '../../Components/BaseComponents/TextToCopy';
export var CheckOrderManager = function () {
    var _a = useState(undefined), wire = _a[0], setWire = _a[1];
    return (_jsxs(_Fragment, { children: [_jsx(ZeroIdBanner, {}), wire === undefined ? (_jsx(SelectPaymentPage, { onSelect: function (type) { return setWire(type); } })) : (_jsx(CheckOrderPage, { backClick: function () { return setWire(undefined); }, paymentType: wire }))] }));
};
var CheckOrderPage = observer(function (_a) {
    var paymentType = _a.paymentType, backClick = _a.backClick;
    var isDirectPayment = useFeatureFlag(FeatureFlag.DIRECT_PAYMENT);
    var _b = useOrder(), amounts = _b.amounts, rate = _b.rate;
    var _c = useApplication(), stepController = _c.stepController, orderFacade = _c.orderFacade, _d = _c.orderFacade, wirePayment = _d.wirePayment, getPaymentInfo = _d.getPaymentInfo;
    var smartContractData = useNFT();
    var track = useAnalytics().track;
    var _e = useState(false), loading = _e[0], setLoading = _e[1];
    var _f = useState(false), fetchError = _f[0], setFetchError = _f[1];
    var fromInfo = orderFacade.exchangeInfo.payAmountString;
    var realFromInfo = orderFacade.exchangeInfo.payRealAmountString;
    var toInfo = smartContractData
        ? smartContractData.name
        : orderFacade.exchangeInfo.receiveAmountString;
    var feeInfo = orderFacade.exchangeInfo.totalFeeString;
    var target = orderFacade.userInfo.address;
    var course = orderFacade.exchangeInfo.rateString;
    var message = 'message' in stepController.currentStep
        ? stepController.currentStep.message
        : undefined;
    var createdWalletAddress = useMemo(function () {
        return 'walletAddress' in stepController.currentStep
            ? stepController.currentStep.walletAddress
            : '';
    }, [stepController.currentStep]);
    useEffect(function () {
        track('summary_loaded');
        // Намерено пропущены deps
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var paymentFunction = useMemo(function () {
        return {
            wire: function () { return wirePayment(); },
            card: function () {
                return getPaymentInfo(isDirectPayment ? PaymentMethod.DIRECT : PaymentMethod.IFRAME);
            },
        };
    }, [wirePayment, getPaymentInfo, isDirectPayment]);
    var handleSubmit = useCallback(function () {
        setLoading(true);
        setFetchError(false);
        track('summary_clicked', undefined, {
            final_exchange_rate: rate,
            final_amount_to_pay: amounts.from.amount,
        });
        paymentFunction[paymentType]()
            .catch(function (err) {
            setFetchError(true);
        })
            .finally(function () {
            setLoading(false);
        });
    }, [amounts.from.amount, paymentFunction, paymentType, rate, track]);
    var actionBtnError = fetchError
        ? 'Something went wrong. Try again'
        : undefined;
    return (_jsxs(PageLayout, __assign({ customBackClick: backClick, hideHeaderChip: true, footer: {
            buttonClick: handleSubmit,
            actionButtonLabel: 'Next',
            actionButtonLoader: loading,
            actionBtnError: actionBtnError,
        } }, { children: [_jsxs("div", __assign({ style: { display: 'flex', alignItems: 'center', gap: 8 } }, { children: [_jsx(MainText, { children: "Review your order" }), message ? (_jsx(Tooltip, __assign({ defaultVisible: true, content: _jsx("div", { children: message.content }), width: "325px", position: "bottom" }, { children: _jsx(WarningIcons, {}) }))) : null] })), _jsxs("div", __assign({ className: styles.table }, { children: [_jsxs("div", __assign({ className: styles.row, "data-test-id": "you-will-receive" }, { children: [_jsx("p", __assign({ className: styles.table_content }, { children: "You will receive" })), toInfo && _jsx(OrderValueWithTooltip, { value: toInfo })] })), _jsxs("div", __assign({ className: styles.row, "data-test-id": "you-btc-wallet" }, { children: [_jsx("p", __assign({ className: styles.table_content }, { children: "Your wallet" })), _jsx("p", __assign({ className: styles.content_with_tooltip }, { children: _jsx(TextToCopy, __assign({ textToCopy: target || createdWalletAddress }, { children: middleDots(target || createdWalletAddress) })) }))] })), _jsxs("div", __assign({ className: styles.row, "data-test-id": "total-fee" }, { children: [_jsx("div", __assign({ className: styles.row }, { children: _jsxs("p", __assign({ className: "".concat(styles.table_content, " ").concat(styles.icon) }, { children: ["Total fee", _jsx(TotalFeeInfoIcon, {})] })) })), _jsxs("p", __assign({ className: "".concat(styles.table_content, " ").concat(styles.bold) }, { children: [realFromInfo ? '≈ ' : null, feeInfo] }))] })), _jsxs("div", __assign({ className: styles.row, "data-test-id": "exchange-rate" }, { children: [_jsxs("div", __assign({ className: "".concat(styles.row, " ").concat(styles.gap) }, { children: [_jsx("p", __assign({ className: styles.table_content }, { children: "Exchange rate" })), _jsx(RateIcon, {})] })), course && _jsx(OrderValueWithTooltip, { value: course })] }))] })), _jsx("div", { children: smartContractData ? null : (_jsxs("div", __assign({ className: styles.total_block }, { children: [_jsxs("div", __assign({ className: styles.row, "data-test-id": "total-payment" }, { children: [_jsx("p", __assign({ className: styles.table_content }, { children: realFromInfo ? 'Total paid amount' : 'Total payment' })), _jsxs("p", __assign({ className: "".concat(styles.table_content, " ").concat(styles.bold) }, { children: [realFromInfo ? '≈ ' : null, fromInfo] }))] })), realFromInfo ? (_jsxs("div", __assign({ className: styles.row, "data-test-id": "total-payment" }, { children: [_jsx("p", __assign({ className: styles.table_content }, { children: "You will be charged" })), _jsx("p", __assign({ className: "".concat(styles.table_content, " ").concat(styles.bold) }, { children: realFromInfo }))] }))) : null] }))) }), isDirectPayment || paymentType !== 'card' ? null : (_jsx(PaymentCardTypeSelect, {}))] })));
});
